import * as constants from './constants';
import { createActions as createFormWidgetActions } from '../../components/Form/Widget';
import { createActionCreator } from '../../lib/Actions';

const createAction = createActionCreator('RESOURCES');

export const mainForm = createFormWidgetActions(constants.RESOURCE_FORM_MAIN);
export const externalForm = createFormWidgetActions(constants.RESOURCE_EXTERNAL_FORM);
export const placesForm = createFormWidgetActions(constants.RESOURCE_PLACES_FORM);
export const filesForm = createFormWidgetActions(constants.RESOURCE_FILES_FORM);

export const POST = createAction('POST', ({ id, form, values, url }) => ({ id, form, values, url }));
export const UPDATE = createAction('UPDATE', ({ id, form, values }) => ({ id, form, values }));
